import apiClient from '@/api/client';

export interface ProxyRule {
  name: string;
  field: string; // from|to|subject|cc
  contains: string;
  fileinto: string | null;
  forward: string | null;
  stop: boolean;
}

export interface ExistingRule {
  name: string;
  summary: string;
  simple: boolean;
  field: string | null;
  contains: string | null;
  fileinto: string | null;
  forward: string | null;
  stop: boolean;
}

export interface FiltersData {
  script_name: string;
  total_existing: number;
  existing: ExistingRule[];
  rules: ProxyRule[];
}

const enc = encodeURIComponent;

export async function getFilters(address: string): Promise<FiltersData> {
  const { data } = await apiClient.get<FiltersData>(`/mailboxes/${enc(address)}/filters`);
  return data;
}

export async function saveFilters(address: string, rules: ProxyRule[]): Promise<FiltersData> {
  const { data } = await apiClient.put<FiltersData>(`/mailboxes/${enc(address)}/filters`, { rules });
  return data;
}

export interface ExistingEdit {
  field: string;
  contains: string;
  fileinto: string | null;
  forward: string | null;
  stop: boolean;
}

export async function editExistingRule(address: string, name: string, payload: ExistingEdit): Promise<FiltersData> {
  const { data } = await apiClient.put<FiltersData>(
    `/mailboxes/${enc(address)}/filters/existing/${enc(name)}`,
    payload
  );
  return data;
}

export async function deleteExistingRule(address: string, name: string): Promise<FiltersData> {
  const { data } = await apiClient.delete<FiltersData>(
    `/mailboxes/${enc(address)}/filters/existing/${enc(name)}`
  );
  return data;
}

// --- Kunde-Filter -----------------------------------------------------------
// Drei Felder rein, alles andere entsteht auf dem Server. `preview` schreibt
// nichts und ist die Grundlage fuer den "Pruefen"-Knopf.

export interface KundeInput {
  vorname: string;
  nachname: string;
  email: string;
  alias?: string | null;
}

export interface KundeIssue {
  code: string;
  message: string;
  blocking: boolean;
  position: number | null;
}

export interface KundePreview {
  vorname: string;
  nachname: string;
  email: string;
  alias: string;
  folder: string;
  match_field: string;
  rule_name: string;
  ok: boolean;
  issues: KundeIssue[];
}

export async function previewKunde(address: string, payload: KundeInput): Promise<KundePreview> {
  const { data } = await apiClient.post<KundePreview>(
    `/mailboxes/${enc(address)}/filters/kunde/preview`,
    payload
  );
  return data;
}

export async function createKunde(address: string, payload: KundeInput): Promise<KundePreview> {
  const { data } = await apiClient.post<KundePreview>(
    `/mailboxes/${enc(address)}/filters/kunde`,
    payload
  );
  return data;
}
